<template>
  <v-container fluid fill-height style="position:fixed; top: 0; z-index: 10">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Bonjour, qui êtes-vous ?</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form @submit.prevent>
              <v-text-field prepend-icon="person" name="login" label="Login" type="text" v-model="email"></v-text-field>
              <v-text-field prepend-icon="lock" name="password" label="Password" id="password" type="password" v-model="password"></v-text-field>
            </v-form>
            <v-alert :value="error" type="warning">{{error}}</v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading || signing" @click="login">Me connecter</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'

export default {
  name: 'Login',
  data(){
    return {
      email: '',
      password: '',
      error: null,
      signing: false
    }
  },
  computed: {
    ...mapState(['loading']),
  },
  methods : {
    login : function () {
      this.signing = true
      this.$fb.auth.signInWithEmailAndPassword(this.email, this.password).then(() => {
        console.log('login ok')
        this.$router.push('/')
      }).catch(() => {
          this.error = "Nous n'avons pas réussi à vous identifier, désolé."
          this.signing = false
      })
    }
  }
}
</script>

<style scoped>

</style>
